"use client";

import type { ReactNode } from "react";
import { motion, useReducedMotion } from "@/lib/motion";
import HeroGlow from "./hero-glow";

interface ContactPageProps {
  leftColumn: ReactNode;
  formContent: ReactNode;
  successContent: ReactNode;
  submitted: boolean;
}

export function ContactPage({
  leftColumn,
  formContent,
  successContent,
  submitted,
}: ContactPageProps) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <main id="main-content" tabIndex={-1} className="relative overflow-y-clip pb-32">
      <HeroGlow align="left" />

      <div className="relative mx-auto max-w-7xl px-4 pt-32 pb-16 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-4xl items-start gap-12 lg:grid-cols-[1fr_1.3fr] lg:gap-16">
          <motion.div
            initial={prefersReducedMotion ? false : { opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          >
            {leftColumn}
          </motion.div>

          <motion.div
            initial={prefersReducedMotion ? false : { opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          >
            {submitted ? successContent : formContent}
          </motion.div>
        </div>
      </div>
    </main>
  );
}
